import "@fortawesome/fontawesome-svg-core/styles.css";
import "@fontsource/public-sans/latin-400.css";
import "@fontsource/public-sans/latin-600.css";
import "@fontsource/public-sans/latin-700.css";
import "@fontsource/public-sans/latin-800.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { AppRoutes } from "./App";
import { AuthProvider } from "./auth";
import { ApplicationErrorBoundary } from "./components/ApplicationErrorBoundary";
import { ProductionLandingPage } from "./pages/ProductionLandingPage";
import { isProductionPreview, isProductionSite } from "./production-host";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("Application root is missing");

createRoot(root).render(
  <StrictMode>
    <ApplicationErrorBoundary>
      {isProductionSite() || isProductionPreview() ? (
        <ProductionLandingPage />
      ) : (
        <BrowserRouter>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </BrowserRouter>
      )}
    </ApplicationErrorBoundary>
  </StrictMode>,
);
